<div class="col-lg-6">Welcome to the administration interface!</div>
